// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3_KF6","overflowing":"ReadFullNote_overflowing__2_Hvn"};